import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './MenuPage.scss';
import { buildUrl } from '../../utils/helper';
import withMeta from '../../utils/withMeta';
import { useLocation, useNavigate } from 'react-router';
import ButtonComponent from '../../buttons/Button';
import LoadingPanel from '../../LoadingPanel';

/**
 * Komponent reprezentujúci stránku s menu.
 * @component
 * @param {object} props - The props object.
 * @param {object} props.meta - Metadata with meta.menu..
 * @param {string} props.title - The title of the page.
 * @param {string} props.subtitle - The subtitle of the page.
 * @param {bool} props.hideHeader - Hide header of page
 * @returns {JSX.Element} The rendered MenuPage component.
 */
const MenuPage = ({ meta, title, subtitle, hideHeader = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuItem, setMenuItem] = useState(null)

  useEffect(() => {

    const menuId = location.state?.id;
    let currentMenu = null

    if (location.pathname === "/menu" && menuId) {
      currentMenu = meta.menu.find(x => x.MenuID === menuId);
    }
    else if (location.pathname !== "/menu") {
      currentMenu = meta.menu.find(x => x.Route === location.pathname);
    }
    else {
      navigate("/")
    }

    if (!currentMenu && location.pathname !== "/") {
      navigate("/")
    }
    setMenuItem(currentMenu);

  }, [location, navigate, meta.menu])

  const onClick = (item) => {
    if (item.Route) {
      navigate(item.Route)
    }
    else {
      navigate("/menu", { state: { id: item.MenuID } })
    }
  }

  const goBack = () => {
    const nadMenu = meta.menu.find(x => x.MenuID === menuItem.NadMenuID)
    if (nadMenu.Route) {
      navigate(nadMenu.Route)
    }
    else {
      navigate("/menu", { state: { id: menuItem.NadMenuID } })
    }
  }

  const children = meta.menu.filter(x => x.NadMenuID === menuItem?.MenuID && x.Visible !== 3) || [];

  return (
    <div className='menu-page'>
      {!menuItem && !meta.menuError ?
        <LoadingPanel isLoading={true} />
        :
        <>
          {menuItem?.NadMenuID && <ButtonComponent className={"menu-page-back"} label={""} onClick={goBack} imageUrl={buildUrl("assets/icons/spät.svg")} />}
          {!hideHeader && <div className="menu-page-header">
            <div className='menu-page-title'>{title || menuItem?.NadMenuID ? menuItem.Title : ""}</div>
            <div className='menu-page-subtitle'>{subtitle || menuItem?.Tooltip}</div>
          </div>}

          <div className="menu-page-list" >
            {children.map(item => <div key={item.MenuID} onClick={() => onClick(item)}>
              <div className="card" >
                <div className="card-body">
                  {item.Icon && <img src={buildUrl(item.Icon)} alt={item.Title} className='pb-2' />}
                  <h5 className="menu-page-card-title">{item.Title}</h5>
                  <p className="menu-page-card-text">{item.Tooltip}</p>
                </div>
              </div>
            </div>)}
          </div>
        </>
      }
    </div>
  );
}

MenuPage.propTypes = {
  meta: PropTypes.object.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  hideHeader: PropTypes.bool
};

export default withMeta(MenuPage);